const BADGE_STATUS = {
	newData: "NEW_DATA_RECEIVED",
	dataRequested: "REQUESTED",
	readyToSend: "READY_TO_SEND",
	inProgress: "IN_PROGRESS",
	sent: "SENT",
	delivered: "DELIVERED",
	deliveryFailed: "DELIVERY_FAILED",
	packageRequested: "PACKAGE_REQUESTED",
	packageDeclined: "PACKAGE_DECLINED",
	received: "RECEIVED",
	receiving: "RECEIVING",
	receiveFailed: "RECEIVE_FAILED"
};

function formatStatusOption(status) {
	if (status === BADGE_STATUS.newData) {
		return {
			id: BADGE_STATUS.newData,
			label: "New data",
		};
	}

	if (status === BADGE_STATUS.dataRequested) {
		return {
			id: BADGE_STATUS.dataRequested,
			label: "Data requested",
		};
	}

	if (
		status === BADGE_STATUS.readyToSend ||
		status === BADGE_STATUS.inProgress
	) {
		return {
			id: BADGE_STATUS.inProgress,
			label: "In progress",
		};
	}

	if (status === BADGE_STATUS.sent) {
		return {
			id: BADGE_STATUS.sent,
			label: "Sending",
		};
	}

	if (status === BADGE_STATUS.delivered) {
		return {
			id: BADGE_STATUS.delivered,
			label: "Sent",
		};
	}

	if (status === BADGE_STATUS.deliveryFailed || status === BADGE_STATUS.receiveFailed) {
		return {
			id: BADGE_STATUS.deliveryFailed,
			label: "Failed",
		};
	}

	if (status === BADGE_STATUS.packageRequested) {
		return {
			id: BADGE_STATUS.packageRequested,
			label: "Package requested",
		};
	}

	if (status === BADGE_STATUS.packageDeclined) {
		return {
			id: BADGE_STATUS.packageDeclined,
			label: "Declined",
		};
	}

	if (status === BADGE_STATUS.received) {
		return {
			id: BADGE_STATUS.received,
			label: "Received",
		};
	}
}

export { BADGE_STATUS, formatStatusOption };
